<template>
  <nav>
    <ul class="pagination">
      <li :class="{ disabled: current == 1 }">
        <a href="javascript:;" @click="setCurrent(current - 1)" style="width: 60px;"> 上一页 </a>
      </li>
      <!-- <li :class="{ disabled: current == 1 }">
        <a href="javascript:;" @click="setCurrent(1)" style="width: 60px;"> 首页 </a>
      </li> -->
      <li v-for="(p, idx) in grouplist" :class="{ active: current == p.val }" :key="idx">
        <a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a>
      </li>
      <!-- <li :class="{ disabled: current == page }">
        <a href="javascript:;" @click="setCurrent(page)" style="width: 60px;"> 尾页 </a>
      </li> -->
      <li :class="{ disabled: current == page }">
        <a href="javascript:;" @click="setCurrent(current + 1)" style="width: 60px;"> 下一页</a>
      </li>
      <!-- <li class="pageination-input">
        <input v-model="value" />
        <span  @click="just">跳转</span>
      </li>
      <li class="total">
        共{{total}}条
      </li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      current: this.currentPage,
      value: 1,
    };
  },
  props: {
    total: {
      // 数据总条数
      type: Number,
      default: 0,
    },
    display: {
      // 每页显示条数
      type: Number,
      default: 10,
    },
    currentPage: {
      // 当前页码
      type: Number,
      default: 1,
    },
    pagegroup: {
      // 分页条数
      type: Number,
      default: 5,
      coerce: function (v) {
        v = v > 0 ? v : 5;
        return v % 2 === 1 ? v : v + 1;
      },
    },
  },
  computed: {
    page: function () {
      // 总页数
      return Math.ceil(this.total / this.display);
    },
    grouplist: function () {
      // 获取分页页码
      var len = this.page,
        temp = [],
        list = [],
        count = Math.floor(this.pagegroup / 2),
        center = this.current;
      if (len <= this.pagegroup) {
        while (len--) {
          temp.push({ text: this.page - len, val: this.page - len });
        }
        return temp;
      }
      while (len--) {
        temp.push(this.page - len);
      }
      var idx = temp.indexOf(center);
      idx < count && (center = center + count - idx);
      this.current > this.page - count && (center = this.page - count);
      temp = temp.splice(center - count - 1, this.pagegroup);
      do {
        var t = temp.shift();
        list.push({
          text: t,
          val: t,
        });
      } while (temp.length);
      // if (this.page > this.pagegroup) {
      //   this.current > count + 1 &&
      //     list.unshift({ text: "...", val: list[0].val - 1 });
      //   this.current < this.page - count &&
      //     list.push({ text: "...", val: list[list.length - 1].val + 1 });
      // }
      return list;
    },
  },
  methods: {
    setCurrent: function (idx) {
      if (this.current != idx && idx > 0 && idx < this.page + 1) {
        this.current = idx;
        this.$emit("pagechange", this.current);
      }
    },
    change(val) {
      this.current = parseInt(val.target.value);
    },
    just() {
      if( this.value && !isNaN(this.value)){
        if( this.value == this.current ) return
        if( this.value > this.page ) {
          this.value = this.page
        } else if( this.value <= 0 ){
          this.value = 1
        }
        this.current = Number(this.value)
      } else {
        this.value = 1
        this.current = 1
      }
      this.$emit("pagechange", this.current)
    }
  },
};
</script>

<style lang="less" scoped>
.pagination {
  overflow: hidden;
  display: table;
  margin: 0 auto;
  /*width: 100%;*/
  height: 50px;

  li {
    font-size: 18px;
    float: left;
    border-radius: 5px;
    margin: 0 5px;
    color: #fff;
    background-color: #3945A8;
    a {
      display: block;
      width: 40px;
      // padding: 8px 10px;
      padding: 8px 0px;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      text-decoration: none;
    }
    &.pageination-input {
      background: transparent;
      input {
        display: inline-block;
        vertical-align: middle;
        height: 35px;
        width: 60px;
        background: #fff;
        border-radius: 6px;
        color:#888;
        text-align: center;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        height: 35px;
        width: 60px;
        line-height: 35px;
        margin-left: 10px;
        border-radius: 6px;
        background-color: #3945A8;
        cursor: pointer;
      }
    }
    &.total {
      font-size: 14px;
      background: transparent;
      line-height: 35px;
    }
  }
  .active {
    background: #B38A1F;
    a {
      color: #fff;
    }
  }
}
</style>